import Vue from 'vue';
import VueI18n from 'vue-i18n';
import config from './helpers/configProvider';

Vue.use(VueI18n);

function loadLocaleMessages() {
  const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i);
  const messages = {};
  locales.keys().forEach((key) => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      const locale = matched[1];
      messages[locale] = locales(key);
    }
  });
  return messages;
}

const language = window.$cookies.get('language');

export default new VueI18n({
  locale: language || config.getEnv(config.enum.VUE_APP_I18N_LOCALE) || 'hu',
  fallbackLocale: config.getEnv(config.enum.VUE_APP_I18N_FALLBACK_LOCALE) || 'hu',
  messages: loadLocaleMessages()
});
